import { useState } from 'react';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import { Row, Col, Icon, } from 'antd';
import TranslatedText from "translations/TranslatedText";
import Button from "antd/es/button/button";
import AnswersModal from './AnswersModal';

export function getShortName(quizName) {
  if (quizName.includes('China Quiz')) {
    return 'china';
  } else if(quizName.includes('Placement Test')) {
    return 'placement';
  } else if(quizName.includes('Hanzi')) {
    return 'hanzi';
  }
  return quizName;
}

function getChinaMessage(score) {
  if (score >= 0 && score <= 7) {
    return `student.message.finished.${quizShortName}.score.low`;
  } else if (score >= 8 && score <= 14) {
    return `student.message.finished.${quizShortName}.score.medium`;
  } else if (score >= 15) {
    return `student.message.finished.${quizShortName}.score.high`;
  }
}

function getHanziLevel1(score) {
  if (score < 5 ) {
    return `student.message.finished.${quizShortName}.level1.score.low`;
  } else if (score >= 5) {
    return `student.message.finished.${quizShortName}.level1.score.high`;
  }
}

function getHanziLevel2(score) {
  if (score < 3 ) {
    return `student.message.finished.${quizShortName}.level2.score.low`;
  } else if (score >= 3) {
    return `student.message.finished.${quizShortName}.level2.score.high`;
  }
}

function getHanziLevel3(score) {
  if (score < 3 ) {
    return `student.message.finished.${quizShortName}.level3.score.low`;
  } else if (score >= 3) {
    return `student.message.finished.${quizShortName}.level3.score.high`;
  }
}

function getHanziMessage(quizName, score) {
  if (quizName.includes('Level 1')) return getHanziLevel1(score);
  if (quizName.includes('Level 2')) return getHanziLevel2(score);
  if (quizName.includes('Level 3')) return getHanziLevel3(score);
}

function getMessage(quizName, score) {
  if (quizShortName.includes('china')) return getChinaMessage(score);
  if (quizShortName.includes('hanzi')) return getHanziMessage(quizName, score);
}

let quizShortName;

export default function Score(props) {
  const {
    score,
    numQuestions,
    quizName,
    showAnswers,
    quiz,
  } = props;
  quizShortName = getShortName(quizName);
  const message = getMessage(quizName, score);
  const [visible, setVisible] = useState(false);

  const handleClick = () => {
    setVisible(true);
    // open modal
    // view
      // row - question name
      // row - question
      // row
        // col answer
        // col text explanation
      // row
        // col next button
        // previous button
    // use carousel to navigate answers
  }

  return (
    <>
      <Row type="flex" justify="center" align="middle">
        <Col>
          <Row type="flex" justify="center">
            <Col>
              <Text style={{ color: 'black', fontFamily: 'AvenirNextLTPro-Regular', fontSize: '1.5em', }} type="primary">
                <TranslatedText id="student.message.finished.score.label" />
              </Text>
            </Col>
          </Row>
          <Row style={{ marginBottom: '5%', }} type="flex" justify="center">
            <Col>
              <Text style={{ color: 'black', fontFamily: 'AvenirNextLTPro-Bold', fontSize: '1.5em', }} type="primary">
                <Icon type="check" style={{ color: '#52c41a' }} />{`${score}/${numQuestions}`}
              </Text>
            </Col>
          </Row>
          <Row style={{ fontFamily: 'AvenirNextLTPro-Regular', }} type="flex" justify="center">
            <Col>
              <Text style={{ color: '#737373' }}>
                <TranslatedText id={message} />
              </Text>
            </Col>
          </Row>
          {
            message && (
              <Row style={{ marginBottom: '10%', fontFamily: 'AvenirNextLTPro-Regular', }} type="flex" justify="center" align="middle">
                <Col>
                  <Text style={{ color: '#737373' }}>
                    <TranslatedText id={`student.message.finished.${quizShortName}.score.conclusion`} />
                  </Text>
                </Col>
              </Row>
            )
          }
          {
            showAnswers && (
              <Row type="flex" justify="center">
                <Col>
                  <Button onClick={handleClick} style={{ backgroundColor: "#FF5A00", border: 'none', }} type="primary">
                    <TranslatedText id={"student.message.finished.answers.button"} />
                  </Button>
                </Col>
              </Row>
            )
          }
        </Col>
      </Row>
      <AnswersModal
        visible={visible}
        onCancel={() => setVisible(false)}
        quiz={quiz}
        quizName={quizName}
      />
    </>
  )
}